export default "__VITE_ASSET__15b9629d__"